export const whatWeOfferPoints = [
    "Experienced and dynamic team",
    "Innovative approach",
    "Strong technical setup",
    "Commitment to quality",
    "Adhering to time schedule",
    "Reasonable price",
    "Excellence through experience",
    "Customer satisfaction",
    "Excellent after sales service",
    "Quality products",
    "On time delivery",
    "Quick follow up"
]

export const lifeCareProductsWhatWeHaveDetails = [
    {
      "heading": "Pharmaceutical",
      "imageName": "drug.png",
      "content": "Fundamental components of both modern and traditional medicine are safe, effective, and of good quality. They areprescribed and used rationally."
    },
    {
      "heading": "Nutraceuticals",
      "imageName": "turnkey-services.png",
      "content": "Food or fortified food products that not only supplements the diet but also assists in treating or preventing disease(apart from anaemia), so provides medical benefits."
    },
    {
      "heading": "Herbal",
      "imageName": "cardiogram-2.png",
      "content": "Derived from plants. Plants have been the basis for medical treatments through much of human history, and suchtraditional medicine is still widely practiced today."
    },
    {
      "heading": "Veterinary",
      "imageName": "hospital.png",
      "content": "Veterinary medicine is the branch of medicine that deals with the prevention, control, diagnosis and treatment ofdisease, disorder and injury in animals."
    },
    {
      "heading": "Cosmetics",
      "imageName": "cardiogram-2.png",
      "content": "Products to enhance the appearance of the face, fragrance or the texture of the body. Many cosmetics are designed foruse of applying to the face and body."
    },
    {
      "heading": "Active Pharmaceutical Ingredients",
      "imageName": "hospital.png",
      "content": "Abbreviated as API, it is the part of any drug that produces the intended effects. These are the ingredientsthat are biologically active in any pharmaceutical drug."
    }
  ];
  
  export const pharmatechWhatWeHaveDetails = [
    {
      "heading": "Pharma IT Solution",
      "imageName": "drug.png",
      "content": "With our experienced professionals and proven domain expertise, we ensure you to give best-in-class IT soltions foryour business."
    },
    {
      "heading": "Turnkey Project Management",
      "imageName": "turnkey-services.png",
      "content": "We take full responsibility of your plant infrastructure development and every top to bottom issues related to yourplant."
    },
    {
      "heading": "Quality Management System",
      "imageName": "cardiogram-2.png",
      "content": "Our very interesting area of working is quality management system in which we do all kinds of GMP, GLP and QMS auditsfor your organization."
    },
    {
      "heading": "Human Resource Management",
      "imageName": "hospital.png",
      "content": "In human resource management, our well-experienced team recruits and trains candidates on your behalf according to yourneed and urgency."
    },
    {
      "heading": "Validation & Calibration Services",
      "imageName": "cardiogram-2.png",
      "content": "We have a team fully equipped with high accuracy calibration, validation and HVAC instruments to provide best service in this domain."
    },
    {
      "heading": "Drug Discovery & Formulation Development",
      "imageName": "hospital.png",
      "content": "Comprehensive range of services across the drug lifecycle from drug discovery & development to commercialmanufacturing of drug products."
    }
  ];

  export const clientFeedbacks = [
    "The quality of the medication I received continues to be excellent, consistently providing the intended therapeutic benefits and contributing positively to my health management. I appreciate the reliable efficacy and the consistent physical attributes of each dose.",
    "I have full confidence in the quality of the medicines dispensed; the clear labeling, secure packaging, and the overall appearance of the product instill a strong sense of trust in its integrity and safety for consumption.",
    "The comprehensive information provided with the medication, detailing usage and precautions, is very helpful and reflects a commitment to ensuring patients are well-informed about their treatment. This level of detail adds to my positive perception of the product's quality.",
    "The delivery of my prescription was exceptionally prompt and arrived well within the expected timeframe, ensuring I had timely access to my necessary medication without any disruption. The efficiency of the delivery service is truly appreciated.",
    "I was very impressed with the packaging of my recent order; it was robust and carefully designed to protect the medication during transit, ensuring it arrived in perfect condition without any signs of damage or mishandling.",
    "The communication regarding my order and its delivery status was excellent, with timely updates provided at each stage. The transparency and proactive information made the entire process smooth and hassle-free.",
    "I am consistently satisfied with both the high quality of the medication I receive and the seamless efficiency of the logistics involved in its delivery. This reliable combination provides significant peace of mind regarding my ongoing treatment.",
    "The entire process, from the ordering of my prescription to its timely and secure arrival, has been consistently positive. The dedication to maintaining high standards in both product quality and logistical execution is truly commendable."
  ]

  export const contactDetaisFooter = [
    {
      name : "Address:",
      value : "A;12 F,1ST Floor, Above SBI, Big B Complex, Baddi, 173205"
    },
    {
      name : "Phone:",
      value : "+91 84060 11111"
    },
    {
      name : "Email:",
      value : "martandlifecare@gmail.com"
    }
  ];

  export const homeScreenBannerDetails = [
    {
      "imageName": "martandlife-7.jpg",
      "heading": "Allopathic",
      "content": "Fundamental components of both modern and traditional medicine are safe, effective, and of good quality. They are prescribed and used rationally."
    },
    {
      "imageName": "martandlife-12.jpg",
      "heading": "Nutraceuticals",
      "content": "Food or fortified food products that not only supplements the diet but also assists in treating or preventing disease (apart from anaemia), so provides medical benefits."
    },
    {
      "imageName": "martandlife-9.jpg",
      "heading": "Herbal",
      "content": "Derived from plants. Plants have been the basis for medical treatments through much of human history, and such traditional medicine is still widely practiced today."
    },
    {
      "imageName": "martandlife-11.jpg",
      "heading": "Veterinary",
      "content": "Veterinary medicine is the branch of medicine that deals with the prevention, control, diagnosis and treatment of disease, disorder and injury in animals."
    },
    {
      "imageName": "martandlife-8.jpg",
      "heading": "Cosmetics",
      "content": "Products to enhance the appearance of the face, fragrance or the texture of the body. Many cosmetics are designed for use of applying to the face and body."
    },
    {
      "imageName": "martandlife-10.jpg",
      "heading": "Active Pharmaceutical Ingredients",
      "content": "Abbreviated as API, it is the part of any drug that produces the intended effects. These are the ingredients that are biologically active in any pharmaceutical drug."
    }
  ];

  export const aboutUsStripDetails = [
    {
      "name": "Quality Products",
      "imageName": "icon-quality.png"
    },
    {
      "name": "Customer Satisfaction",
      "imageName": "icon-satisfaction.png"
    },
    {
      "name": "On-time Delivery",
      "imageName": "icon-delivery.png"
    },
    {
      "name": "Innovative Approach",
      "imageName": "icon-idea.png"
    }
  ]